import React, { Component } from 'react';
import { Box } from '@mui/material';
import { isEmpty } from 'lodash'
import { SingleSwitch, GroupSwitch } from '../../common/RadioAndCheckbox';
import Dialog from '../../common/Dialog';

class BudgetActiveCat extends Component {
    state = { 
        // checked : [],
        isActive: {},
    }
    componentDidMount = () => {
        const { CATEGORIES } = this.props;
        let list = {}
        Object.values(CATEGORIES.PARENT).forEach( cat => {
            list[cat.category_id] = cat.budget_active
        })
        console.log('==================CDM==================');
        console.log({list});
        console.log('====================================');
        this.setState({ isActive: list })
    }
    handleCheck = (category_id) => {
        let isActive = Object.assign({}, this.state.isActive) 
        isActive[category_id] = !isActive[category_id]
       
        // let checked = Object.keys(isActive).filter(ID => isActive[ID])

        this.setState({                
            isActive,
            // checked
        })
    }
    getCategoriesList = () => {
        const { CATEGORIES } = this.props;
        
        if (!isEmpty(CATEGORIES.PARENT)){
            let list = Object.values(CATEGORIES.PARENT)
            return list.map(item => 
                <Box>
                    <SingleSwitch
                        checked={this.state.isActive[item.category_id]} 
                        label={item.category_name}  
                        onChange={() => this.handleCheck(item.category_id) }
                    />
                </Box>
            )
        }
    }

    handleSubmit = async () => {
        await this.props.updateActiveBudget(this.state.isActive)
        if(this.props.STATE.categories.error){
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.categories.error}`)
        } else{
            this.props.update && this.props.notif("success","La liste a été modifiée avec succès")
            this.props.handleClose()
        }
    }
    render() {
        return (
            <Dialog
                open={true}
                title="Catégories Actives"
                close={this.props.handleClose}
                submitAction={this.handleSubmit}
                disabledSubmit={this.props.STATE.categories.fetching}
            >
                <GroupSwitch
                    name="activeCats"
                >
                    {this.getCategoriesList()}
                </GroupSwitch>
            </Dialog>
        );
    }
}

export default BudgetActiveCat;